var map = {
	"./01.svg": "2a99",
	"./02.svg": "2493",
	"./03.svg": "4dc7",
	"./04.svg": "708c",
	"./09.svg": "93be",
	"./10.svg": "2f28",
	"./11.svg": "7b9d",
	"./13.svg": "73a8",
	"./50.svg": "c33f",
	"./humidity.svg": "74aa",
	"./pressure.svg": "8ae2",
	"./sunrise.svg": "024a",
	"./sunset.svg": "5cb9",
	"./waves.svg": "27da",
	"./wind.svg": "0847"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c875";